import { createMessages } from 'estafette-intl';
import { common } from './common';
import { nomenclatures } from './nomenclatures';

export const messages = createMessages([common, nomenclatures]);
